import { render } from "./Bancos.vue?vue&type=template&id=f0216ed2&scoped=true"
import script from "./Bancos.vue?vue&type=script&lang=js"
export * from "./Bancos.vue?vue&type=script&lang=js"

import "./Bancos.vue?vue&type=style&index=0&id=f0216ed2&scoped=true&lang=scss"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0216ed2"]])

export default __exports__